import type { JSXElementConstructor } from 'react';

export const renderFlag = (Flag: JSXElementConstructor<any>, className?: string) => <Flag className={className} />;
